// Menu.tsx
import React from "react";
import styled from "styled-components";
import { screenSizes } from "../../styles/theme";

interface Item {
  icon: JSX.Element;
  title: string;
}

interface MenuProps {
  items: Item[];
  onSelect: (item: string) => void;
  isVisible: boolean;
}

const MenuContainer = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  position: absolute;
  top: 70px;
  right: 0;
  width: 280px;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 1000;
  @media (max-width: ${screenSizes.L}px) {
    right: 10px;
    left: 10px;
    margin-inline: auto;
    top: 52px;
  }
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 24px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  @media (max-width: ${screenSizes.L}px) {
    height: 65px;
  }
  p {
    font-size: 18px;
    font-weight: 600 !important;
    line-height: 24px;
    color: #091c00 !important;
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(204, 204, 204, 1);
  }
`;

const MenuComponent: React.FC<MenuProps> = ({ items, onSelect, isVisible }) => {
  return (
    <MenuContainer isVisible={isVisible}>
      {items.map((item, index) => (
        <MenuItem key={index} onClick={() => onSelect(item?.title)}>
          {item?.icon}
          <p>{item?.title}</p>
        </MenuItem>
      ))}
    </MenuContainer>
  );
};

export default MenuComponent;
